import { RUNTIME_CONFIG } from './runtimeConfig';

export const CUSTOMER_SERVICE_BASE_URL = RUNTIME_CONFIG.customerServiceBaseUrl;
export const CUSTOMER_SERVICE_UNREAD_ENDPOINT = RUNTIME_CONFIG.customerServiceUnreadEndpoint;
